import { useLocation } from 'react-router';

/**
 * Replacement for useSearchParams when using only react-router (not react-router-dom).
 * Returns a URLSearchParams instance for the current location's search string.
 */
export function useQueryParams(): URLSearchParams {
  const { search } = useLocation();
  return new URLSearchParams(search);
}
